import { Component, Input, OnInit } from '@angular/core';
import { DocumentosService } from '~core/api/documentos.service';
import { fieldsRotas } from '~pages/config/relatorio/config-relatorio/add-campo-dialog/const';
import { utils as xlsUtils, WorkBook, WorkSheet, writeFile as writeXls } from 'xlsx';
import { RotaDetalhesRelatorioVO } from '~model/vo/RelatorioTabelaVO';

@Component({
  selector: 'app-relatorio-dinamico-xls',
  templateUrl: './relatorio-dinamico-xls.component.html',
  styleUrls: ['./relatorio-dinamico-xls.component.scss'],
  providers: [DocumentosService],
})
export class RelatoriDinamicoXlsComponent implements OnInit {
  @Input() listaFields: any[] = [];
  @Input() resumo!: RotaDetalhesRelatorioVO;
  visitas: any[] = [];

  // Objeto que irá armazenar os dados para cada campo
  dataMap: { [key: string]: any } = {};

  constructor() { }

  ngOnInit(): void {
    const filteredFields = fieldsRotas.filter(field => this.resumo.header.includes(field.value));

    const keptIndices: number[] = [];
    this.listaFields = this.resumo.header
      .map((headerValue: string, index: number) => {
        const field = filteredFields.find(f => f.value === headerValue);
        if (field) {
          keptIndices.push(index);
        }
        return field;
      })
      .filter((field: any) => field !== undefined);

    // Filtra as células de cada row para manter apenas as posições cujo header foi mantido
    this.visitas = this.resumo.rows.map(row =>
      keptIndices.map(i => (row as any[])[i])
    );
  }

  getValue(fildValue: any) {
    return fildValue ? fildValue : "-";
  }

  baixarXls(): void {
    const ws: WorkSheet = xlsUtils.json_to_sheet(
      this.resumo.rows.map((row) =>
        row.reduce((acc, value, index) => {
          acc[this.resumo.header[index]] = value;
          return acc;
        }, {} as Record<string, any>)
      )
    );
    const wb: WorkBook = xlsUtils.book_new();
    xlsUtils.book_append_sheet(wb, ws, 'Resumo');
    const name = `Resumo_Rota_${new Date().toISOString().slice(0, 10)}.xlsx`;
    writeXls(wb, name);
  }

  print(): void {
    window.print();
  }

}
